// extracted by mini-css-extract-plugin
module.exports = {"list":"NavigationFooter_list___dbI2","item":"NavigationFooter_item__Atw05","link":"NavigationFooter_link__ArP0t"};